module.exports = __webpack_public_path__ + "img/jiliang_home_icon.ac07918.png";